import * as React from 'react';
import Upload from './Upload';
import { RouteComponentProps } from 'react-router';

export class UploadDetails extends React.Component<RouteComponentProps<{}>, {}> {
    render() {
        return <div>
            <Upload fileType={this.props.match.params["fileType"]} />
        </div>
    }
}